"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableRateListConfig = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../Icon");
exports.tableRateListConfig = [
    {
        Header: 'Name',
        accessor: 'name',
    },
    {
        Header: () => 'Info',
        id: 'info',
        Cell: () => {
            return (react_1.default.createElement("span", { className: 'table__action-icons' },
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'edit' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'check-list' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
        },
    },
];
//# sourceMappingURL=tableRateListConfig.js.map